import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import {
    Button, Link, Box, Flex, Text
} from 'components/ui';
import { colors } from 'style/config';
import localeUtils from 'utils/LanguageLocale';
import SaveForLaterConfirmationBoxEN from 'components/RwdBasket/Carts/CartLayout/SaveForLaterConfirmationBox/locales/SaveForLaterConfirmationBox_en_US';
import SaveForLaterConfirmationBoxFR from 'components/RwdBasket/Carts/CartLayout/SaveForLaterConfirmationBox/locales/SaveForLaterConfirmationBox_fr_CA';

const { getLocalisedDataFromResource } = localeUtils;

function SaveForLaterConfirmationBox({
    basketConfirmation, basketType, onDismiss, onUndo, onOpenModal
}) {
    if (!basketConfirmation || basketConfirmation.basketType !== basketType) {
        return null;
    }

    const getText = getLocalisedDataFromResource(SaveForLaterConfirmationBoxEN, SaveForLaterConfirmationBoxFR);
    const { brandName, productName } = basketConfirmation;

    const renderGotItButton = size => (
        <Button
            variant='secondary'
            size={size}
            onClick={onDismiss}
            aria-label={`${getText('gotIt')} - ${brandName} ${productName} ${getText('confirmationAriaLabel')}`}
            children={getText('gotIt')}
            data-at={Sephora.debug.dataAt('bsk_save_for_later_confirmation_got_it_button')}
        />
    );

    const handleUndoKeyDown = e => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onUndo();
        }
    };

    const handleSaveForLaterLinkKeyDown = e => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onOpenModal();
        }
    };

    return (
        <Box
            role='status'
            aria-live='polite'
            aria-atomic='true'
            borderBottom={`1px solid ${colors.lightGray}`}
            marginX={[3, 4]}
            paddingY={4}
        >
            <Flex
                backgroundColor={colors.nearWhite}
                borderRadius={2}
                flexDirection='column'
                gap={3}
                paddingX={[3, 4]}
                paddingY={3}
            >
                <Text
                    is='p'
                    fontSize={['sm']}
                    data-at={Sephora.debug.dataAt('bsk_save_for_later_confirmation_label')}
                >
                    <Text
                        fontWeight='bold'
                        children={`${brandName} ${productName}`}
                    />
                    {` ${getText('movedToSaveForLater')} `}
                    <Link
                        role='button'
                        tabIndex={0}
                        color={colors.blue}
                        css={styles.saveForLaterLink}
                        onClick={onOpenModal}
                        onKeyDown={handleSaveForLaterLinkKeyDown}
                        aria-label={`${getText('saveForLater')} - ${getText('viewSavedItems')}`}
                        children={getText('saveForLater')}
                        data-at={Sephora.debug.dataAt('bsk_save_for_later_confirmation_link')}
                    />
                </Text>
                <Flex
                    alignItems='center'
                    gap={3}
                >
                    {renderGotItButton('xs')}
                    <Link
                        role='button'
                        tabIndex={0}
                        color={colors.blue}
                        fontSize={['sm']}
                        onClick={onUndo}
                        onKeyDown={handleUndoKeyDown}
                        aria-label={`${getText('undo')} - ${getText('moveBackToBasket')} ${brandName} ${productName}`}
                        children={getText('undo')}
                        data-at={Sephora.debug.dataAt('bsk_save_for_later_confirmation_undo_button')}
                    />
                </Flex>
            </Flex>
        </Box>
    );
}

const styles = {
    saveForLaterLink: {
        display: 'inline',
        textDecoration: 'none'
    }
};

export default wrapFunctionalComponent(SaveForLaterConfirmationBox, 'SaveForLaterConfirmationBox');
